class ProductCardAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector("details");
    this.summaryToggle   = this.querySelector("summary");
    this.summaryIsEmpty  = this.summaryToggle.textContent.trim().length === 0;

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );

    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );

    document.addEventListener("matchSmall",   this.close.bind(this));
    document.addEventListener("unmatchSmall", this.open.bind(this));

    if (this.summaryIsEmpty) {
      this.detailsContainer.setAttribute("open", "");
      this.detailsContainer.setAttribute("empty", "");
    } else {
      this.detailsContainer.removeAttribute("open");
    }
  }

  connectedCallback() {
    this.container = this.closest(".js-product-card-accordion-container");
    this.updateHeight();
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.detailsContainer.hasAttribute("open") ? this.close() : this.open();
  }

  open() {
    this.detailsContainer.setAttribute("open", "");
    this.updateHeight();
  }

  close() {
    if (!this.summaryIsEmpty) {
      this.detailsContainer.removeAttribute("open");
      this.updateHeight();
    }
  }

  updateHeight() {
    if (!this.container) return;
    const { height } = this.getBoundingClientRect();
    this.container.style.setProperty(
      "--product-accordion-height",
      `${Math.round(height)}px`
    );
  }
}

customElements.define("product-card-accordion", ProductCardAccordion);